import { lazy } from "react";

// Wraps React.lazy to auto-recover from stale chunk errors after a deploy.
// If a dynamic import fails (chunk not found because the bundle changed),
// reload the page once instead of showing a blank screen.
export function lazyWithRetry(importer) {
  return lazy(async () => {
    const reloadKey = "chunk_reload_attempt";
    try {
      return await importer();
    } catch (error) {
      const alreadyReloaded = window.sessionStorage.getItem(reloadKey);
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(reloadKey, "1");
        window.location.reload();
        return { default: () => null };
      }
      throw error;
    }
  });
}
